import { render, staticRenderFns } from "./BtnIcon.vue?vue&type=template&id=77d2db02&lang=pug&"
import script from "./BtnIcon.vue?vue&type=script&lang=js&"
export * from "./BtnIcon.vue?vue&type=script&lang=js&"
import style0 from "./BtnIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports